module.exports = __webpack_public_path__ + "img/69.73318a1c.jpg";